export const SET_CURRENT_BATCH   = 'SET_CURRENT_BATCH'
export const SET_HISTORY         = 'SET_HISTORY'
export const SET_IS_POLLING      = 'SET_IS_POLLING'
export const SET_IS_DISPATCHING  = 'SET_IS_DISPATCHING'
export const SET_IS_CANCELLING   = 'SET_IS_CANCELLING'
